const map = require('lodash/fp/map');
const memoizer = require('../request-handler/utils/memoizer');

function serviceFactory({ api }) {
  const pushRegistration = memoizer()((inputs, metaData) =>
    api.pushRegistration(inputs, metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );

  const getFCMSenderId = memoizer()((metaData) =>
    api.getFCMSenderId(metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );

  return {
    pushRegistration,
    getFCMSenderId,
  };

}

module.exports = serviceFactory;
